import { getApiErrorDetail, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Carrier, CreateCarrier } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { carrierKeys, createCarrierApi } from '../api';

export function useCreateCarrier(): UseMutationResult<Carrier, Error, CreateCarrier> {
  const client = useApiClient('admin-auth');
  const api = createCarrierApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<Carrier, Error, CreateCarrier>({
    mutationFn: (data: CreateCarrier) => api.createCarrier(data),
    onError: (error: Error) => {
      const detail = getApiErrorDetail(error);
      if (detail.errorCode === 'Conflict.DuplicateCarrierName') {
        toast.error(t('spaces.settings.carriers.toast.errorDuplicateName'));
      } else if (detail.errorCode === 'Conflict.DuplicateCarrierCode') {
        toast.error(t('spaces.settings.carriers.toast.errorDuplicateCode'));
      } else {
        toast.error(detail.message || t('spaces.settings.carriers.toast.createError'));
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: carrierKeys.lists() });
    },
  });
}
